import React from 'react';
import { useNavigate } from 'react-router-dom';
import $, { event } from "jquery";
import { useState } from 'react';
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import PreLoginApi from '../../../components/Api/PreLoginApi';
import preLoginGetApi from '../../../components/Api/PreLoginGetApi';
import FooterContact from '../FooterContact';


const StepTwo = () => {
    let navigate = useNavigate();
    const [data, setData] = useState({});


    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }


    const [input, setInput] = useState({});
    useEffect(()=>{
        const tokenParam = new URLSearchParams(window.location.search).get('token')?.toString().replaceAll(" ","+");
        if( tokenParam === null || tokenParam === undefined || tokenParam === "" ) {
            return navigate("/");
        }

        // Now Check by API call
        try {
            PreLoginApi("panel/company-registration-request/validateToken",JSON.stringify({token: tokenParam})).then((responseJSON) => {
                
                var response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if( response["status"] === 0 ) {
                    toast.error("A problem occur. Please try again.");
                    return navigate("/");
                }

                let data = JSON.stringify(response["data"]);
                data = JSON.parse(data);
                
                
                if (data["code"] === 200) {
                    const step1 = JSON.parse(data["data"]?.step1);
                    if( step1?.company_email?.length > 0 ) {
                        return navigate("/company-registration-step-three?token="+tokenParam);
                    }
                
                    setData(data["data"]);
                    setInput({...input, token: tokenParam, 
                        doing_business_as: step1?.doing_business_as ?? data["data"]?.company_name, 
                        email_address: data["data"]?.email_address
                    });
                    return;
                }

                console.log("first");


                // Redirect to login page
                toast.error(data["messages"] ?? "No registration information found.");
                return navigate("/");

                
            }).catch((error) => {
                toast.error(error);
            });
        }
        catch (err) {
            toast.error("No registration information found.");
            console.log(err);
            return navigate("/");
        }

    },[]);


    const [businessCategory, setBusinessCategory] = useState([]);
    useEffect(()=>{
        try {
            preLoginGetApi("api/v1/panel/company-registration-request/business/category-all-pre-login",).then((responseJSON) => {
                
                var response = JSON.stringify(responseJSON);
                response = JSON.parse(response);

                if( response["status"] === 0 ) {
                    toast.error("A problem occur. Please try again.");
                }
                
                let data = JSON.stringify(response["data"]);
                data = JSON.parse(data);

                if (data["code"] === 200) {
                    setBusinessCategory(data["data"]);
                    return;
                }


                // redirect to login page
                toast.error(data["messages"]);

                
            }).catch((error) => {
                toast.error(error);
            });
        }
        catch(err) {
            toast.error("A problem occur. Please try again.");
            console.log(err);
        }
    },[]);



    const handleSubmit = event => {
        event.preventDefault();
        
        if(!isValidEmail(input.company_email)) {
            toast.error('Company Email is invalid.');
            return;
        }

        if(input.mobile_number?.length < 11) {
            toast.error('Phone number is invalid.');
            $("#mobile_number").focus();
            return;
        }

        if(input.doing_business_as?.length === 0 ) {
            toast.error("Please enter doing business as.");
            return;
        }

        if(input.business_category?.length === 0 ) {
            toast.error("Please select business category.");
            return;
        }


        // Now call API to store and proceed to next
        PreLoginApi("panel/company-registration-request/initialize",JSON.stringify(input)).then((responseJSON) => {
                
            var response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if( response["status"] === 0 ) {
                toast.error("A problem occur. Please try again.");
                return;
            }
            
            let data = JSON.stringify(response["data"]);
            data = JSON.parse(data);

            if (data["code"] === 200) {
                toast.success(data["messages"] ?? "Information added successfully");
                return navigate("/company-registration-step-three?token="+input.token);
            }


            toast.error(data["messages"]);
            
        }).catch((error) => {
            toast.error(error);
        });
        
    }



    const handleChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        
        if( name === "mobile_number" ) {
            if(isNaN(value)) {
                return;
            }

            if(value.length > 13 ) {
                return;
            }

            value = value.toString().replaceAll(".","");
        }

        setInput({...input, [name] : value});
    }

    useEffect(()=>{
        $('.btn').css({ opacity: '0.6' });
        $('.btn').attr("disabled", true);

        let email = input.company_email;
        if(isValidEmail(email)) {
            $('.btn').css({ opacity: '1' });
            $('.btn').attr("disabled", false);
        }

    },[input]);


    const cancelProceed = () => {
        if(window.confirm("Are you sure want to cancel ?")) {
            document.location.href="/";
            return;
        }
    }


    return (
        <section className="h-screen bg-white font-murecho">
            <ToastContainer />
            <div className="h-full justify-center">
                {/* <!-- Left column container with background--> */}


                <div className="flex h-full flex-wrap items-center justify-center lg:justify-center">


                    {/* <!-- Right column container --> */}
                    <div className="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">

                        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">

                            <div className="w-full bg-[#1882FF] rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
                                <div className="p-6 sm:p-10">

                                    <p className='text-white text-xl'>Welcome to</p>

                                    <p className="mb-6 font-semibold leading-8 text-white text-[25px] dark:text-white">
                                        ShareTrip Partner Registration
                                    </p>


                                    
                                    <form onSubmit={handleSubmit} method="POST">
                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Company Name (As per Trade License)</p>
                                        <div className='mb-2'>
                                            <input type="text" name="company_name" value={data?.company_name ?? ""} disabled={true} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Company Name (As per Trade License)" />
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Your Email Address</p>
                                        <div className='mb-2'>
                                            <input type="email" name="email" value={data?.email_address ?? ""} disabled={true} autoComplete='off' id="email" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="E-mail" />
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Business Category *</p>
                                        <div className='mb-2'>
                                            {businessCategory.length > 0 && 
                                                <select name="business_category" defaultValue={input.business_category ?? ""} onChange={handleChange} className='bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed' required={true} >
                                                    <option value="" className='text-gray-300'>Select One</option>
                                                    {businessCategory.map((data, index)=>
                                                        <option value={data.id} key={index} className='text-black'>{data.name}</option>
                                                    )}

                                                </select>
                                            }
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Doing Business As *</p>
                                        <div className='mb-2'>
                                            <input type="text" name="doing_business_as" value={input.doing_business_as ?? data.company_name ?? ""} onChange={handleChange} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Doing Business As" required={true} />
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Company Mobile Number *</p>
                                        <div className='mb-2'>
                                            <input type="number" name="mobile_number" id="mobile_number" value={input.mobile_number ?? ""} onChange={handleChange} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Company Mobile Number" required={true} />
                                        </div>

                                        <p className='text-white font-medium text-sm mb-0.5 ml-1'>Company Email Address *</p>
                                        <div className='mb-2'>
                                            <input type="email" name="company_email" value={input.company_email ?? ""} onChange={handleChange} autoComplete='off' className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 disabled:bg-slate-200 disabled:cursor-not-allowed" placeholder="Company Email Address" required={true} />
                                        </div>


                                        <button id="submit_btn" disabled={true} className="btn mt-4 w-full mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center opacity-60 disabled:cursor-not-allowed">
                                            Verify & Next
                                        </button>


                                        <p className='text-white text-sm text-right mr-1'>
                                            <span onClick={cancelProceed} className="cursor-pointer text-sm font-medium text-white text-right ml-1">
                                                Cancel Registration ?
                                            </span>
                                        </p>

                                    </form>
                                    
                                </div>
                            </div>

                            <FooterContact />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default StepTwo;